import URI from 'jsuri';
import Q from 'q';

import API from 'js/lib/api';

import type { SalesforceCase } from 'bundles/enterprise-admin-contracts/utils/SalesforceCaseUtils';

export type SalesforceAuthUrl = string;

export type SalesforceLead = {
  id: string;
  company: string;
  email: string;
  lastName: string;
  firstName: string;
};

export type List<T> = {
  elements: T[];
};

// Salesforce API
const salesforceCaseAPI = API('/api/salesforceCase.v1', { type: 'rest' });
const salesforceAuthAPI = API('/api/salesforceAuthentication.v1', { type: 'rest' });
const salesforceLeadsAPI = API('/api/salesforceLeads.v1', { type: 'rest' });

const SalesforceAPI = {
  getAuthorizeUrl() {
    const uri = new URI('getAuthorizeUrl');
    return Q<SalesforceAuthUrl>(salesforceAuthAPI.get(uri.toString()));
  },

  getCaseById(id: string, useSandbox = false) {
    const fields = [
      'id',
      'caseNumber',
      'createdDate',
      'status',
      'opportunityName',
      'typeOfProductOnRelatedOpportunity',
      'licensesEnrollmentsOnOpportunity',
      'type',
      'orderProductName',
      'orderProductQuantity',
      'orderProductTermInMonths',
      'orderProductCode',
      'enterpriseWideEnrollmentCap',
      'upperCapOfLicenses',
      'billable',
      'licenseRotationTcEnabled',
      'accountGroup',
      'c4gDealType',
      'customLicenseRotation',
    ];
    const uri = new URI(id).addQueryParam('useSandbox', useSandbox).addQueryParam('fields', fields.join(','));
    return Q<List<SalesforceCase>>(salesforceCaseAPI.get(uri.toString()));
  },

  getLeadByEmail(email: string) {
    const fields = ['id', 'firstName', 'lastName', 'email', 'company'];
    const uri = new URI()
      .addQueryParam('q', 'findByEmail')
      .addQueryParam('email', email)
      .addQueryParam('fields', fields.join(','));

    return Q<List<SalesforceLead>>(salesforceLeadsAPI.get(uri.toString()));
  },
};

export default SalesforceAPI;
